import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";

import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const SwitchLabelStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      fontSize: "14px",
      paddingRight: 10,
      color: "#7B858B",
    },
  }),
);

export const SecondarySwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 55,
  height: 26,
  padding: 2,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 5,
    bottom: 0,
    transitionDuration: "300ms",
    transform: "translateX(-2px)",
    "&.Mui-checked": {
      transform: "translateX(27px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#FC4C4C",
        opacity: 1,
        border: 0,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "#E5E7E8",
    },
  },
  "& .MuiSwitch-thumb": {
    background: "linear-gradient(122.32deg, #FFFFFF 28.41%, #F8F9F9 133.47%)",
    boxSizing: "border-box",
    width: 20,
    height: 20,
  },
  "& .MuiSwitch-track": {
    boxShadow: "inset 0px -1px 1px #DADCDD",
    opacity: 1,
    backgroundColor: "#E5E7E8",
    borderRadius: 26 / 2,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
